import React, {Component} from "react";
import {connect} from "react-redux";
import URLSearchParams from 'url-search-params'
import {Redirect, Route, Switch} from "react-router-dom";
import {LocaleProvider} from "antd";
import {IntlProvider} from "react-intl";

import AppLocale from "lngProvider";
import MainApp from "./MainApp";
import SignIn from "../SignIn";
import SignUp from "../SignUp";
import SignUpMayor from "../SignUpMayor";
import ForgotPassword from '../ForgotPassword';
// import {setInitUrl, getUserInfo} from "appRedux/actions/Auth";
// import {getAllClients, getAllMajorists} from "appRedux/actions/User";
import AuthActions from "../../appRedux/redux/Auth";
import UserActions from "../../appRedux/redux/User";
import SettingsActions from "appRedux/redux/Setting";

import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  THEME_TYPE_DARK
} from "../../constants/ThemeSetting";

const RestrictedRoute = ({component: Component, user, ...rest}) =>
  <Route
    {...rest}
    render={props =>
      user
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: '/signin',
            state: {from: props.location}
          }}
        />}
  />;

class App extends Component {

  setLayoutType = (layoutType) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('full-layout');
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('boxed-layout');
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('full-layout');
      document.body.classList.add('framed-layout');
    }
  };

  setNavStyle = (navStyle) => {
    if (navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER) {
      document.body.classList.add('full-scroll');
      document.body.classList.add('horizontal-layout');
    } else {
      document.body.classList.remove('full-scroll');
      document.body.classList.remove('horizontal-layout');
    }
  };

  componentWillMount() {
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }

    const params = new URLSearchParams(this.props.location.search);

    if (params.has("theme")) {
      this.props.setThemeType(params.get('theme'));
    }
    if (params.has("nav-style")) {
      this.props.onNavStyleChange(params.get('nav-style'));
    }
    if (params.has("layout-type")) {
      this.props.onLayoutTypeChange(params.get('layout-type'));
    }
    
  }

  async componentDidMount() {
    const user = await localStorage.getItem('user');
    if (JSON.parse(user)) await this.props.setUserData(JSON.parse(user));
  }

  render() {
    const {match, location, themeType, layoutType, navStyle, locale, user, initURL} = this.props;
    if (themeType === THEME_TYPE_DARK) {
      document.body.classList.add('dark-theme');
    }
    const userRole = (user && user.rol) ? user.rol : 'noRole';
    if (location.pathname === '/') {
      if (user == null) {
        return ( <Redirect to={'/signin'}/> );
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        switch (userRole) {
          case 'admin':
            return ( <Redirect to={'/adminDashboard'}/> );
          case 'client':
            return ( <Redirect to={'/clientDashboard'}/> );
          case 'major':
            return ( <Redirect to={'/mayorDashboard'}/> );
          default:
            return ( <Redirect to={'/'}/> );
        }
      } else {
        console.log(initURL);
        return ( <Redirect to={initURL}/> );
      }
    }

    this.setLayoutType(layoutType);

    this.setNavStyle(navStyle);

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <LocaleProvider locale={currentAppLocale.antd}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}>
          <Switch>
            <Route exact path='/signin' component={SignIn}/>
            <Route exact path='/signup' component={SignUp}/>
            <Route exact path='/signupmayor' component={SignUpMayor}/>
            <Route exact path='/forgotPassword' component={ForgotPassword} />
            <RestrictedRoute 
              path={`${match.url}`} 
              user={user}
              component={MainApp}/>
          </Switch>
        </IntlProvider>
      </LocaleProvider>
    )
  }
}

const mapStateToProps = ({ settings, auth, user: u }) => {
  const {locale, navStyle, themeType, layoutType} = settings;
  const { initURL } = auth;
  const { user } = u;
  return {locale, navStyle, themeType, layoutType, user, initURL}
};

const mapActionsToState = () => {
  const { setInitUrl } = AuthActions;
  const { setUserData, getAllClients, getAllMajors } = UserActions;
  return { setInitUrl, setUserData, getAllClients, getAllMajors };
}


export default connect(mapStateToProps, {
  ...SettingsActions,
  ...mapActionsToState()
})(App);
